var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 44 27",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 27,
    rx: 2.322683,
    width: 43.382114
  }), /*#__PURE__*/React.createElement("rect", {
    height: 25,
    rx: 2.322683,
    stroke: "#959799",
    strokeWidth: 2,
    width: 41.382114,
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#959799"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 6h43v6h-43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 17h7v4h-7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardDefaultIcon);
export default __webpack_public_path__ + "static/media/credit_card_default_icon.80439e986bb4d8b37d2fdebc926b5916.svg";
export { ForwardRef as ReactComponent };